import React from 'react'
import VehicleNote from '../2_Confirm/VehicleNote/VehicleNote'
import VehicleConfirm_Main from '../2_Confirm/ConfirmBody/VehicleConfirm_Main'
import { DeleteVehicleContext, DeleteVehicleContextComp } from '../RemoveVehicleContext/DeleteVehicleContext'
import RemoveVehicleBtnNav from '../1_Vehicle/RemoveVehicleBtnNav/RemoveVehicleBtnNav'
import { RemoveVehicleContext } from '../RemoveVehicleContext/RemoveVehicleContext'


const ConfirmRemoveVehicleMain = () => {
    return (
        <>
            <DeleteVehicleContextComp>
                <span className='px-md-5'>
                    <VehicleConfirm_Main requestContext={RemoveVehicleContext} vehicleContext={DeleteVehicleContext} reqClass={"removeVehicleClass"} endorsementType={"Remove Vehicle"} /> 
                </span>
                <hr />
                <VehicleNote />
                <hr />
                <RemoveVehicleBtnNav />
            </DeleteVehicleContextComp>
        </>
    )
}

export default ConfirmRemoveVehicleMain